module.exports = __webpack_public_path__ + "img/divnotex_logo_small.27c463ed.png";